module.exports = __webpack_public_path__ + "img/TRIODOSBANK.ecf93ea3.jpg";